module.exports = __webpack_public_path__ + "static/media/water-drop.b3a1355d.svg";